import { render, staticRenderFns } from "./transport.vue?vue&type=template&id=e4a673fa&scoped=true&"
import script from "./transport.vue?vue&type=script&lang=js&"
export * from "./transport.vue?vue&type=script&lang=js&"
import style0 from "./transport.vue?vue&type=style&index=0&id=e4a673fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a673fa",
  null
  
)

export default component.exports